/*
  Secure localStorage helpers using simple encryption with an env secret.
  Env: REACT_APP_STORAGE_SECRET
  Exports: setSecureItem, getSecureItem, removeSecureItem
*/

function getSecret() {
    const secret = process.env.REACT_APP_STORAGE_SECRET;
    if (!secret || secret.trim() === '') {
        throw new Error('Missing REACT_APP_STORAGE_SECRET');
    }
    return secret;
}

function simpleEncrypt(text, secret) {
    let result = '';
    for (let i = 0; i < text.length; i++) {
        const charCode = text.charCodeAt(i) ^ secret.charCodeAt(i % secret.length);
        result += String.fromCharCode(charCode);
    }
    return btoa(result);
}

function simpleDecrypt(encryptedText, secret) {
    const decoded = atob(encryptedText);
    let result = '';
    for (let i = 0; i < decoded.length; i++) {
        const charCode = decoded.charCodeAt(i) ^ secret.charCodeAt(i % secret.length);
        result += String.fromCharCode(charCode);
    }
    return result;
}

export function setSecureItem(key, value) {
    try {
        const secret = getSecret();
        const dataString = typeof value === 'string' ? value : JSON.stringify(value);
        const encrypted = simpleEncrypt(dataString, secret);
        localStorage.setItem(key, encrypted);
        return true;
    } catch (err) {
        console.error('setSecureItem error', err);
        return false;
    }
}

export function getSecureItem(key) {
    try {
        const raw = localStorage.getItem(key);
        if (!raw) return null;
        const secret = getSecret();
        const decrypted = simpleDecrypt(raw, secret);
        try {
            return JSON.parse(decrypted);
        } catch (err) {
            if (key === 'userData') {
                localStorage.clear();
                window.location.href = '/';
                return null;
            }
            return decrypted;
        }
    } catch (err) {
        console.error('getSecureItem error', err);
        if (key === 'userData') {
            localStorage.clear();
            window.location.href = '/';
            return null;
        }
        return null;
    }
}

export function removeSecureItem(key) {
    try {
        localStorage.removeItem(key);
        return true;
    } catch (err) {
        console.error('removeSecureItem error', err);
        return false;
    }
}